import React, { memo, useEffect, useRef, useState } from 'react'

import * as _ from 'lodash'
import styled from 'styled-components'
import PerfectScrollbar from 'react-perfect-scrollbar'
import IconPolygon from 'assets/img/icon/icon_polygon.png'
import IconPolygon2 from 'assets/img/icon/icon_polygon_2.png'
import IconMinus from 'assets/img/icon/minus.png'
import Search from 'assets/img/icon/Search.png'
import { connect } from 'react-redux'
import { makeGetAllStock } from 'lib/selector'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
  border: 1px solid ${(props) => (props.isFocus ? '#F0B90B' : '#4e4d62')};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px 8px 12px;
  background: transparent;
  background-image: url(${(props) =>
    props.active ? IconPolygon : IconPolygon2});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 5px);
  background-position-y: 50%;
  color: ${(props) => (props.active ? 'var(--half_white)' : '#818181')};

  .select-value {
    position: relative;
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    height: 14px;
    display: flex;
    overflow: hidden;
  }

  .select-option {
    display: none;
    position: absolute;
    top: 33px;
    left: -2px;
    padding: 0;
    background: #1c192c;
    box-shadow: 0px 10px 24px -4px rgba(255, 255, 255, 0.08),
      0px 4px 8px -4px rgba(255, 255, 255, 0.03);
    border-radius: 4px;
    width: 303px;
    overflow: hidden;
    z-index: 3;

    &.active {
      display: block;
    }

    .scrollbar-container {
      max-height: 200px;
    }

    li {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: var(--half_white);
      padding: 8px 16px;

      &:hover {
        background: #353347;
      }

      .container-checkbox-filter .check_mark {
        top: -2px;
      }
    }
  }

  .input-header {
    border-bottom: 1px solid #4e4d62;

    background: transparent;
    background-image: url(${Search});
    background-repeat: no-repeat;
    background-position-x: calc(100% - 12px);
    background-position-y: 50%;

    .form-control {
      border: 0;
      padding: 8px 36px 12px 16px;
    }
  }

  .text-header {
    padding: 10px 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    width: 100%;
    display: flex;
    // grid-template-columns: auto auto;
    // gap: 5px;

    span {
      align-self: center;
    }
  }
`

const GroupSymbol = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 1px;

    width: 16px;
    height: 16px;
    margin-right: 8px;

    border: 1px solid #58567a;
    border-radius: 2px;

  &.active{
    background: #F0B90B;
    border-color: #F0B90B;
  }
`

function RenderMultiSelect(props) {
  const wrapperRef = useRef()
  const [show, setShow] = useState(false)
  const [showText, setShowText] = useState('')
  const [arrChecked, setArrChecked] = useState([])
  const [arrShow, setArrShow] = useState([])

  const {
    input: { value, onChange },
    isActive,
    allStock,
    meta: { touched, error },
  } = props

  useEffect(() => {
    setArrShow(allStock)
  }, [])

  useEffect(() => {
    if (value) {
      setArrChecked(value.split(','))
    }
  }, [value])

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside)
    // See note below
    return () => window.removeEventListener('mousedown', handleClickOutside)
  })

  function _handleShow() {
    setShow(true)
  }

  function handleClickOutside(event) {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShow(false)
    }
  }

  function handleChange(e) {
    const { name, checked } = e.target
    let _newArr = _.clone(arrChecked)
    if (checked) {
      // thêm mới
      _newArr.push(name)
      setArrChecked(_newArr)
    } else {
      _.remove(_newArr, (o) => o === name)
      setArrChecked(_newArr)
    }
    onChange(_newArr.join(','))
  }

  function handleChangeText(e) {
    const { value } = e.target
    setShowText(value)
    if (value && value.trim()) {
      setArrShow(
        _.filter(allStock, (o) =>
          o.stock_code.includes(value.trim().toUpperCase())
        )
      )
    } else {
      setArrShow(allStock)
    }
  }

  function handleClose() {
    // let _newArr = _.clone(arrChecked)
    // _.remove(_newArr, (o) => _.some(arr, (t) => t === o))
    setArrChecked([])
    onChange('')
  }

  //   console.log(allStock)

  return (
    <Container ref={wrapperRef} active={isActive || show} isFocus={show} style={{
        borderColor: `${touched && error ? '#FF0000' : '#4e4d62'}`,
      }}>
      <div className="select-value" onClick={_handleShow}>
        {arrChecked && !!arrChecked.length ? arrChecked.join(', ') : 'Chọn'}
      </div>
      <div className={'select-option' + (show ? ' active' : '')}>
        <div className="input-header">
          <input
            type={'text'}
            className="form-control"
            placeholder="Tìm kiếm..."
            value={showText}
            onChange={handleChangeText}
          />
        </div>
        <div className="text-header">
          <GroupSymbol
            className={arrChecked && !!arrChecked.length ? 'active' : ''}
            onClick={() => handleClose()}
          >
            {arrChecked && !!arrChecked.length && (
              <img src={IconMinus} alt="" />
            )}
          </GroupSymbol>
          {arrChecked && (
            <span>Đã chọn: {arrChecked.length} mã chứng khoán</span>
          )}
          {/* {(!arrChecked || !arrChecked.length) && <span>Tất cả</span>} */}
        </div>
        <PerfectScrollbar>
          <ul>
            {arrShow &&
              !!arrShow.length &&
              arrShow.map((item, index) => (
                <li key={index}>
                  <label className="container-checkbox-filter ">
                    {item.stock_code}
                    <input
                      type="checkbox"
                      name={item.stock_code}
                      id={item.stock_code}
                      checked={_.some(arrChecked, (o) => o === item.stock_code)}
                      onChange={handleChange}
                    />
                    <span className="check_mark" />
                  </label>
                </li>
              ))}
          </ul>
        </PerfectScrollbar>
      </div>
    </Container>
  )
}

const makeMapStateToProps = () => {
  const getAllStock = makeGetAllStock()

  const mapStateToProps = (state) => {
    return {
      allStock: getAllStock(state),
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(memo(RenderMultiSelect))
